<div class="modal-container-content" [formGroup]="this.form">
  <app-input type="email" formControlName="email">Nieuw e-mailadres</app-input>
  @if (this.isSubmitted) {
    <app-error-display [control]="this.form.get('email')"></app-error-display>
  }

  <app-input type="email" formControlName="confirm_email">Nieuw e-mailadres herhalen</app-input>
  @if (this.isSubmitted) {
    <app-error-display [control]="this.form.get('confirm_email')"></app-error-display>
  }

  <app-input type="password" formControlName="current_password">Voer je wachtwoord in</app-input>
  @if (this.isSubmitted) {
    <app-error-display [control]="this.form.get('current_password')"></app-error-display>
  }
</div>

<div class="modal-container-footer">
  <app-button class="[button]" (click)="this.submit()" onkeyup="this.submit()">Wijzigen</app-button>
  <app-button type="outline" (click)="this.modalRef.close()" onKeyUp="">Annuleren</app-button>
</div>
